module.exports = __webpack_public_path__ + "img/acorn-courses.01cfd2f3.png";